import axiosClient from "../../../../system/helpers/axiosConfig";

export const postLandingsOrder = (params) => {
  return axiosClient
    .post(`api/admin/landing-pages/sort`, params)
    .then((r) => r.data.data);
};
